<template>
  <div class="cc-maintenance-screen">
    <v-card
      class="cc-maintenance-card pa-6"
      max-width="540"
      elevation="2"
    >
      <v-card-title class="d-flex align-center">
        <v-icon
          :icon="Icons.WRENCH_OUTLINE"
          size="32"
          color="primary"
          class="mr-3"
        />
        <span>{{ t('maintenance.banner.active.headline') }}</span>
      </v-card-title>
      <v-card-text>
        <p class="text-body-1 mb-4">
          {{ t('maintenance.banner.active.subtitle') }}
        </p>
        <p
          v-if="message"
          class="text-body-1 mb-4"
        >
          {{ message }}
        </p>
        <p
          v-if="endsAt"
          class="text-body-2 text-medium-emphasis"
        >
          {{ t('maintenance.banner.active.endsAt') }}: {{ formattedEndsAt }}
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {useI18n} from 'vue-i18n';
import moment from 'moment';
import {Icons} from '@simpleforyou/client-core';
import {endsAt, message} from '@/composables/common/maintenance/useMaintenance';

const {t} = useI18n();

const formattedEndsAt = computed(() => {
  if (!endsAt.value) {
    return '';
  }
  return moment(endsAt.value).format('DD.MM.YYYY HH:mm');
});
</script>

<style lang="scss" scoped>
.cc-maintenance-screen {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background, #f5f5f5);
  z-index: 99998;
  padding: 16px;
}

.cc-maintenance-card {
  width: 100%;
}
</style>
